import React from "react";
import ReactDOM from "react-dom";

function Modal({ children }){
    return ReactDOM.createPortal(
      <div className="taskApp__modalContainer">
        { children }
      </div>,  
      document.getElementById('modal')
    )
}

export { Modal };